import React, { useEffect, useState } from "react";
import { Button, FloatingLabel, FormLabel } from "react-bootstrap";
import "./Login.scss"
import { Field, FormikProvider, useFormik } from "formik";
import axios from "axios";
import { useLocation } from "wouter";
import { useAuth } from "./authStore";
import { useGetFeatureFlags } from "../api/api";

export default function LoginPage() {
    const { data: featureFlags } = useGetFeatureFlags();
    const enablePasswordLogin = featureFlags?.enable_password_login;

    return <div className="login-page">
        <h1>Fotoding</h1>
        {enablePasswordLogin === undefined ? "Loading..." :
            <>
                {enablePasswordLogin && <PasswordLoginForm />}
                <OidcButton showDivider={enablePasswordLogin} />
            </>
        }
    </div>
}

function PasswordLoginForm() {
    const [location, setLocation] = useLocation();

    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
            stayLoggedIn: false,
        },
        async onSubmit(values, formikHelpers) {
            const result = await axios.postForm("/api/auth/token", values, { validateStatus: null });
            if (result.status === 401) {
                alert("Invalid username or password");
                return;
            }
            const auth = useAuth.getState();
            auth.logIn(result.data.access_token);
            if (values.stayLoggedIn) {
                await auth.createSession();
            }

            const search = new URLSearchParams(window.location.search);
            if (search.has("return_url"))
                setLocation(search.get("return_url")!, { replace: true });
            else
                setLocation("/", { replace: true });
        },
    });

    return (
        <form style={{ display: "contents" }} onSubmit={formik.handleSubmit}>
            <FormikProvider value={formik}>
                <FloatingLabel label="Username">
                    <Field name="username" type="text" className="form-control" placeholder="user" />
                </FloatingLabel>
                <FloatingLabel label="Password">
                    <Field name="password" type="password" className="form-control" placeholder="password" />
                </FloatingLabel>
                <div className="float-right">
                    <FormLabel>
                        <Field name="stayLoggedIn" type="checkbox" /> Stay logged in
                    </FormLabel>
                </div>
                <Button type="submit">Log in</Button>
            </FormikProvider>
        </form>
    );
}

function OidcButton({ showDivider = true }: { showDivider?: boolean }) {
    const [providers, setProviders] = useState<Record<string, { button_text: string }>>({});

    useEffect(() => {
        const fetchProviders = async () => {
            try {
                const response = await axios.get('/api/auth/oidc/providers');
                setProviders(response.data);
            } catch (error) {
                console.error('Failed to fetch OIDC providers:', error);
                setProviders({});
            }
        };

        fetchProviders();
    }, []);

    // If no providers, don't render anything
    if (Object.keys(providers).length === 0) return null;

    return <div className="oidc-login-section">
        {showDivider && (
            <>
                <hr />
                <p>Or log in with:</p>
            </>
        )}
        {!showDivider && <p>Log in with:</p>}
        {Object.entries(providers).map(([providerId, provider]) => (
            <Button
                key={providerId}
                variant="outline-primary"
                onClick={() => {
                    window.location.href = `/api/auth/oidc/login/${providerId}`;
                }}
                className="oidc-button"
            >
                {provider.button_text}
            </Button>
        ))}
    </div>
}

// TODO: get authentication into orval
